export default "__VITE_ASSET__Bztilz4p__"